import React from 'react';
import { Spin, Alert, Skeleton } from 'antd';
import { usePersonalAccessTokensUI } from '../hooks/usePersonalAccessTokensUI';
import { PersonalAccessTokensTable } from './PersonalAccessTokensTable';
import { PersonalAccessTokenCreateModal } from './PersonalAccessTokenCreateModal';
import { PersonalAccessTokenDisplayModal } from './PersonalAccessTokenDisplayModal';

export const PersonalAccessTokensContainer: React.FC = () => {
  const ui = usePersonalAccessTokensUI();

  if (ui.error) {
    return <Alert message='Error' description={ui.error.message} type='error' showIcon />;
  }

  if (ui.loading && ui.tokens.length === 0) {
    return <Skeleton active paragraph={{ rows: 4 }} />;
  }

  return (
    <>
      <PersonalAccessTokensTable data={ui} onCreateClick={ui.openCreateModal} />
      <PersonalAccessTokenCreateModal
        visible={ui.createModalOpen}
        loading={ui.loading}
        onClose={ui.closeCreateModal}
        onSubmit={ui.handleCreateToken}
      />
      <PersonalAccessTokenDisplayModal
        visible={ui.displayModalOpen}
        token={ui.pendingDisplayToken}
        onClose={ui.closeDisplayModal}
      />
    </>
  );
};
